import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from "react";

type SessionBannerMenuContextValue = {
  menu: ReactNode | null;
  setMenu: (menu: ReactNode | null) => void;
};

const SessionBannerMenuContext =
  createContext<SessionBannerMenuContextValue | null>(null);

export const SessionBannerMenuProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [menu, setMenu] = useState<ReactNode | null>(null);

  return (
    <SessionBannerMenuContext.Provider value={{ menu, setMenu }}>
      {children}
    </SessionBannerMenuContext.Provider>
  );
};

export const useSessionBannerMenu = () => {
  const context = useContext(SessionBannerMenuContext);

  if (!context) {
    throw new Error(
      "useSessionBannerMenu must be used within SessionBannerMenuProvider",
    );
  }

  return context;
};